import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hero is-primary is-fullheight" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "columns is-centered" }
const _hoisted_5 = { class: "column is-half" }
const _hoisted_6 = { class: "box has-text-centered" }
const _hoisted_7 = { class: "title is-4 has-text-grey-dark" }
const _hoisted_8 = {
  key: 0,
  class: "content block"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" !Tu cuenta ha sido verificada exitosamente! ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "has-hover" }, " Ya puedes iniciar sesión o volver a tu sesión", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_12 = { key: 1 }




export default /*#__PURE__*/_defineComponent({
  props: {
  verified: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", _hoisted_7, [
                (props.verified == '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_router_link, { to: { name: 'login' } }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _hoisted_11
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_12, " Ha ocurrio un problema, vuelve a intentarlo. "))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})